import { axiosInstance } from '../axios';
import { AUTHENTICATION_URL } from '../config/api.urls';

class AuthService {
  async login(user) {
    return await axiosInstance
      .post(AUTHENTICATION_URL, {
        username: user.username,
        password: user.password,
      })
      .then((response) => {
        if (response.data?.token) {
          window.$cookies.set(
            'Authorization',
            response.data.token,
            null,
            null,
            process.env.VUE_APP_AUTHORIZATION_COOKIE_PATH,
          );
        }
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }

  logout() {
    window.$cookies.remove(
      'Authorization',
      null,
      process.env.VUE_APP_AUTHORIZATION_COOKIE_PATH,
    );
    window.location.href = `${process.env.VUE_APP_HTTP}${process.env.VUE_APP_API_ADDRESS}/logout`;
    return;
  }

  // This works only on vue side.
  // JSP side has its own, equal functionality in main.jsp
  async refreshToken() {
    return await axiosInstance
      .get(`${AUTHENTICATION_URL}/refreshtoken`, {
        headers: { isRefreshToken: true },
      })
      .then((response) => {
        if (response?.data?.token) {
          window.$cookies.set(
            'Authorization',
            response.data.token,
            null,
            null,
            process.env.VUE_APP_AUTHORIZATION_COOKIE_PATH,
          );
        }

        return response;
      })
      .catch((error) => {
        return error;
      });
  }
}

export default new AuthService();
